module.exports = __webpack_public_path__ + "static/media/loading.4ac4cf70.gif";